/* ============================================================
   WGH Cart Guard — wgh-cart-guard.js
   Verwijdert upsell/addon items als het parent product
   uit de winkelwagen wordt verwijderd.
   Voeg toe aan theme.liquid: {{ 'wgh-cart-guard.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  var _busy = false;
  var _origFetch = window.fetch.bind(window);

  function removeOrphans() {
    if (_busy) return;
    _busy = true;

    _origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];

        // Product IDs van niet-addon items die nu in de winkelwagen zitten
        var parentIds = {};
        items.forEach(function (item) {
          var p = item.properties || {};
          if (!p._wgh_addon) parentIds[String(item.product_id)] = true;
        });

        // Zoek orphan addon/upsell items (parent product niet meer aanwezig)
        var updates = {};
        items.forEach(function (item) {
          var p = item.properties || {};
          if (p._wgh_addon === '1' && p._wgh_parent_product && !parentIds[p._wgh_parent_product]) {
            updates[item.key] = 0;
          }
        });

        if (Object.keys(updates).length) {
          return _origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
      })
      .then(function () { _busy = false; })
      .catch(function () { _busy = false; });
  }

  // ── Intercept cart AJAX voor real-time cleanup (cart drawer) ──
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isChange = url.indexOf('/cart/change.js') !== -1 || url.indexOf('/cart/update.js') !== -1;

    if (!isChange) return _origFetch(input, init);

    // Controleer of het een verwijdering betreft
    var body = {};
    try { body = JSON.parse((init && init.body) || '{}'); } catch (e) {}

    var isRemoval = false;
    if (body.quantity === 0) isRemoval = true;
    if (body.updates) {
      Object.keys(body.updates).forEach(function (k) {
        if (body.updates[k] === 0) isRemoval = true;
      });
    }

    return _origFetch(input, init).then(function (res) {
      if (isRemoval) removeOrphans();
      return res;
    });
  };

  // ── Controleer op pagina-load (pakt ook directe cart-aanpassingen op) ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeOrphans);
  } else {
    removeOrphans();
  }
})();
